import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-supplier',
  imports: [RouterModule],
  templateUrl: './admin-supplier.html',
  styleUrl: './admin-supplier.scss',
})
export class AdminSupplier {}
